import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { PlantSearchBeanModel } from 'src/app/models/plant-search-bean.model';

@Injectable({
    providedIn: 'root'
})
export class LiveContractResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    getLiveDetailLines(depot: number) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllLiveDetailLinesByTstampEndPoint + depot + '/' +
            this.configuration.getConfiguration().contractDateTime)).toPromise();
    }

    getLiveDetailLinesForCustomer(depot: number, custId: number) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllLiveDetailLinesByCustomerEndPoint + depot + '/' + custId)).toPromise();
    }

    getLiveContracts(depot: number) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.returnListByTstampEndPoint + depot + '/' +
            this.configuration.getConfiguration().contractDateTime)).toPromise();
    }

    getLiveContractsForDepotALL(depot: number){
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllLiveContractsForDepotEndPoint + depot )).toPromise();
    }

    getLiveContractsForPlant(detailLineDTO: DetaillineDTOModel){
        let plantSearchBeanModel = new PlantSearchBeanModel();
        plantSearchBeanModel.pdesc = detailLineDTO.pdesc;
        plantSearchBeanModel.reg   = detailLineDTO.reg;

        return this.http.post(this.configuration.buildUrl(this.urlEndpoints.getAllLiveContractsForPlantEndPoint), plantSearchBeanModel ).toPromise();
    }

    getContractForLocationAndContract(depot: number,contract: number){
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getcontractforlocationandcontractEndPoint + depot +'/'+ contract ) ).toPromise();
    }
}
